import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { kubernetes } = ApiClient.getInstance()

export const kaapiBYOClusterActions = ActionsSet.make<DataKeys.KaapiBYOClusters>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiBYOClusters],
  cacheKey: DataKeys.KaapiBYOClusters,
})

export const listKaapiBYOClusters = kaapiBYOClusterActions.add(
  new ListAction<DataKeys.KaapiBYOClusters, { namespace: string }>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to list Kaapi BYOClusters', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiBYOClusters)
  }),
)

export const createKaapiBYOCluster = kaapiBYOClusterActions.add(
  new CreateAction<DataKeys.KaapiBYOClusters, { namespace: string; body: any }>(
    async ({ namespace, body }) => {
      Bugsnag.leaveBreadcrumb('Attempting to create Kaapi BYOCluster', { namespace, body })
      const created = await kubernetes.createCustomResource({
        type: DataKeys.KaapiBYOClusters,
        body,
      })
      trackEvent('Create New Kaapi BYOClusterAction', {
        namespace,
        name: pathStr('metadata.name', created),
      })
      return created
    },
  ),
)
